/**
 * 获取 html 节点类型的数据
 * @param {string} domString dom 字符串
 * @returns HTMLNode
 */
const createNode = (domString) => {
  const template = document.createElement('div');
  template.innerHTML = domString;
  return template.firstChild;
};

/**
 * 打开口令引导弹窗
 * @param {function} callback 点击复制回调
 * @param {function} download 点击复制回调
 */
export const openPopUp = (callback, download) => {
  const comfirmString = `${''
  }<div class="openapp-pwd-mask" style="position:fixed; top:0; left:0; width:100vw; height:100vh; background:rgba(0, 0, 0, 0.8); z-index:9999; display:flex; align-items:center; justify-content:center;">${''
  }  <div style="position:relative; width:80.8vw; height:65.6vw; color:#000028; border-radius:4.27vw; background-color:#ffffff; padding:6.4vw; margin-top:-10vw; font-size:4.27vw;">${''
  }    <div class="openapp-pwd-title" style="font-size:4.8vw; text-align:center; font-weight:500; line-height:6.4vw;">温馨提示</div>${''
  }    <div class="openapp-pwd-text" style="margin-top:4.27vw; line-height: 2;">${''
  }      <span style="color:#ff6022;">请复制活动口令后，手动打开腾讯视频APP前往参与，</span>若未下载腾讯视频APP，请<span class="openapp-pwd-download" style="text-decoration:underline;">点击下载</span>${''
  }    </div>${''
  }    <div class="openapp-pwd-btn" style="margin-top:6.4vw; height:10.7vw; color:#ffffff; background-color:#ff6022; text-align:center; line-height:10.7vw; border-radius:5.3vw; font-weight:500;">点击立即复制</div>${''
  }    <div class="openapp-pwd-close-btn" style="position:absolute; right: 0; top: -9.07vw; width:6.4vw; height: 6.4vw;">${''
  }      <img src="https://vfiles.gtimg.cn/vupload/20211029/7dca5a1635474768212.png" style="width:100%; height:100%;" />${''
  }    </div>${''
  }  </div>${''
  }</div>`;

  document.getElementsByTagName('body')[0].appendChild(createNode(comfirmString));
  document.querySelector('.openapp-pwd-mask .openapp-pwd-btn').addEventListener('click', () => {
    callback();
    openToast('您已复制成功，快打开腾讯视频APP参与吧');
  });

  document.querySelector('.openapp-pwd-mask .openapp-pwd-download').addEventListener('click', () => {
    download();
  });

  document.querySelector('.openapp-pwd-mask .openapp-pwd-close-btn').addEventListener('click', () => {
    document.getElementsByTagName('body')[0].removeChild(document.querySelector('.openapp-pwd-mask'));
  });

  document.querySelector('.openapp-pwd-mask').addEventListener('touchmove', (e) => {
    e.preventDefault();
  });
};

/**
 * toast 方法
 * @param {string} text toast 文案
 * @returns 无文案返回空
 */
export const openToast = (text) => {
  if (!text) return;
  const toastString = `${''
  }<div class="openapp-pwd-toast" style="position:fixed; top:0; left:0; width:100vw; height:100vh; background:transparent; z-index:9999; display:flex; align-items:center; justify-content:center;">${''
  }  <div class="openapp-pwd-toast-wrapper" style="display:flex; align-items:center; justify-content:center; min-width:32vw; max-width:80vw; width:-webkit-fit-content; width:fit-content; min-height:unset; line-height:5.33vw;${''
  }  font-size:4vw; padding:4.27vw; white-space:pre-wrap; text-align:center; word-wrap:break-word; border-radius:2.13vw; color:#ffffff; background-color:rgba(0, 0, 0, 0.75); margin:0 auto;">${''
  }    <div class="openapp-pwd-toast-text" style="display:inline-block;">${''
  }      ${text}${''
  }    </div>${''
  }  </div>${''
  }</div>`;

  document.getElementsByTagName('body')[0].appendChild(createNode(toastString));

  setTimeout(() => {
    document.getElementsByTagName('body')[0].removeChild(document.querySelector('.openapp-pwd-toast'));
  }, 2000);
};
